import _Select from "@alifd/next/es/select";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _excluded = ["nextTablePrefix", "value", "onChange", "rules", "name", "renderChildren"];
import React from "react";
import BaseTableField from "./baseTableField";
var SelectField = /*#__PURE__*/function (_BaseTableField) {
  _inheritsLoose(SelectField, _BaseTableField);
  function SelectField() {
    return _BaseTableField.apply(this, arguments) || this;
  }
  var _proto = SelectField.prototype;
  _proto.renderField = function renderField() {
    var field = this.field;
    var _this$props = this.props,
      nextTablePrefix = _this$props.nextTablePrefix,
      value = _this$props.value,
      onChange = _this$props.onChange,
      rules = _this$props.rules,
      name = _this$props.name,
      renderChildren = _this$props.renderChildren,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/React.createElement(_Select, _extends({
      className: nextTablePrefix + "select"
    }, field.init(name, {
      rules: rules
    }, rest)), renderChildren ? renderChildren() : null);
  };
  return SelectField;
}(BaseTableField);
export { SelectField as default };